// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qa-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 0;
}

.qa-input-group {
    display: flex;
    gap: 8px;
}

.qa-input {
    flex: 1 1;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 13px;
}

.qa-input:focus {
    outline: none;
    border-color: #1faeff;
    box-shadow: 0 0 0 3px rgba(31, 174, 255, 0.1);
}

.qa-history {
    flex: 1 1;
    min-height: 0;
    margin-top: 16px;
    padding: 12px;
    background-color: #f8f9fa;
    border-radius: 6px;
    overflow-y: auto;
}

.qa-history h3 {
    margin: 0 0 12px 0;
    font-size: 16px;
    color: #333;
}

.qa-history-loading-more {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 0 2px;
    color: #999;
    font-size: 12px;
}

.qa-item {
    padding: 8px 10px;
    background: white;
    border-radius: 4px;
    margin-bottom: 8px;
    border: 1px solid #e0e0e0;
}

.qa-item:last-child {
    margin-bottom: 0;
}

.qa-question {
    font-size: 14px;
    margin: 0 0 4px 0;
    color: #333;
}

.qa-question .qa-label {
    display: inline-block;
    font-weight: bold;
    width: 18px;
    margin-right: 0;
}

.qa-question .qa-text {
    font-weight: bold;
}

.qa-answer {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    margin: 0;
    color: #000;
    line-height: 1.5;
}

.qa-answer .qa-label {
    flex-shrink: 0;
    font-weight: bold;
    width: 18px;
}

.qa-answer .qa-text {
    flex: 1 1;
    min-width: 0;
    font-weight: normal;
}

.qa-answer .qa-text > *:first-child {
    margin-top: 0;
}

.qa-answer .qa-text > *:last-child {
    margin-bottom: 0;
}

.qa-empty-state {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 24px;
    color: #999;
    max-width: 240px;
    margin: 0 auto;
}

.qa-empty-icon {
    font-size: 32px;
    color: #ccc;
    margin-bottom: 12px;
}

.qa-empty-title {
    margin: 0 0 4px 0;
    font-size: 15px;
    font-weight: 600;
    color: #666;
}

.qa-empty-subtitle {
    margin: 0;
    font-size: 12px;
    color: #999;
    line-height: 1.5;
}

.qa-generating-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    opacity: 0.45;
    color: #777;
}

.qa-generating-state p {
    margin: 8px 0 0;
}

.qa-generating-subtitle {
    font-size: 0.9rem;
    opacity: 0.7;
}

.timestamp-link {
    color: #1faeff;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.2s;
    border-bottom: 1px solid transparent;
    margin: 1px;
}

.timestamp-link:hover {
    color: #17a0e8;
    border-bottom: 1px solid #1faeff;
    text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/Magor/Studio/QATab.css"],"names":[],"mappings":"AAAA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,oBAAoB;IACpB,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,qBAAqB;AACzB","sourcesContent":[".qa-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    min-height: 0;\n}\n\n.qa-input-group {\n    display: flex;\n    gap: 8px;\n}\n\n.qa-input {\n    flex: 1;\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 13px;\n}\n\n.qa-input:focus {\n    outline: none;\n    border-color: #1faeff;\n    box-shadow: 0 0 0 3px rgba(31, 174, 255, 0.1);\n}\n\n.qa-history {\n    flex: 1;\n    min-height: 0;\n    margin-top: 16px;\n    padding: 12px;\n    background-color: #f8f9fa;\n    border-radius: 6px;\n    overflow-y: auto;\n}\n\n.qa-history h3 {\n    margin: 0 0 12px 0;\n    font-size: 16px;\n    color: #333;\n}\n\n.qa-history-loading-more {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 10px 0 2px;\n    color: #999;\n    font-size: 12px;\n}\n\n.qa-item {\n    padding: 8px 10px;\n    background: white;\n    border-radius: 4px;\n    margin-bottom: 8px;\n    border: 1px solid #e0e0e0;\n}\n\n.qa-item:last-child {\n    margin-bottom: 0;\n}\n\n.qa-question {\n    font-size: 14px;\n    margin: 0 0 4px 0;\n    color: #333;\n}\n\n.qa-question .qa-label {\n    display: inline-block;\n    font-weight: bold;\n    width: 18px;\n    margin-right: 0;\n}\n\n.qa-question .qa-text {\n    font-weight: bold;\n}\n\n.qa-answer {\n    display: flex;\n    align-items: flex-start;\n    font-size: 14px;\n    margin: 0;\n    color: #000;\n    line-height: 1.5;\n}\n\n.qa-answer .qa-label {\n    flex-shrink: 0;\n    font-weight: bold;\n    width: 18px;\n}\n\n.qa-answer .qa-text {\n    flex: 1;\n    min-width: 0;\n    font-weight: normal;\n}\n\n.qa-answer .qa-text > *:first-child {\n    margin-top: 0;\n}\n\n.qa-answer .qa-text > *:last-child {\n    margin-bottom: 0;\n}\n\n.qa-empty-state {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 24px;\n    color: #999;\n    max-width: 240px;\n    margin: 0 auto;\n}\n\n.qa-empty-icon {\n    font-size: 32px;\n    color: #ccc;\n    margin-bottom: 12px;\n}\n\n.qa-empty-title {\n    margin: 0 0 4px 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: #666;\n}\n\n.qa-empty-subtitle {\n    margin: 0;\n    font-size: 12px;\n    color: #999;\n    line-height: 1.5;\n}\n\n.qa-generating-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    opacity: 0.45;\n    color: #777;\n}\n\n.qa-generating-state p {\n    margin: 8px 0 0;\n}\n\n.qa-generating-subtitle {\n    font-size: 0.9rem;\n    opacity: 0.7;\n}\n\n.timestamp-link {\n    color: #1faeff;\n    cursor: pointer;\n    text-decoration: none;\n    transition: all 0.2s;\n    border-bottom: 1px solid transparent;\n    margin: 1px;\n}\n\n.timestamp-link:hover {\n    color: #17a0e8;\n    border-bottom: 1px solid #1faeff;\n    text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
